import { useForm } from '@inertiajs/react'
import { buttonClass, fieldClass, label, type Props } from './types'

export default function CreateLink({ copy, toolkits, validity_options }: Pick<Props, 'copy' | 'toolkits' | 'validity_options'>) {
  const form = useForm({ name: '', provider: 'meta', validity_days: 'never', toolkit_slug: '' })
  return <section className="rounded-xl border border-border bg-card p-5">
    <h2 className="font-medium">{label(copy, 'new_link')}</h2>
    <form className="mt-4 flex flex-col gap-4 md:flex-row md:flex-wrap md:items-end" onSubmit={(event) => {
      event.preventDefault()
      form.transform((data) => ({ connection: data }))
      form.post('/cc/external_oauth_connections', {
        preserveScroll: true, onSuccess: () => form.setData('name', ''),
      })
    }}>
      <label className="text-sm md:min-w-60 md:flex-[2]">{label(copy, 'name')}
        <input aria-label={label(copy, 'name')} required maxLength={120} value={form.data.name} placeholder={label(copy, 'name_placeholder')} className={fieldClass} onChange={(e) => form.setData('name', e.target.value)} />
        {form.errors.name && <span role="alert" className="mt-1 block text-destructive">{form.errors.name}</span>}
      </label>
      <label className="text-sm md:min-w-40 md:flex-1">{label(copy, 'provider')}
        <select aria-label={label(copy, 'provider')} value={form.data.provider} className={fieldClass} onChange={(e) => form.setData('provider', e.target.value)}>
          {Object.entries(copy.providers).map(([key, value]) => <option key={key} value={key}>{value}</option>)}
        </select>
      </label>
      {form.data.provider === 'composio' && <label className="text-sm md:min-w-40 md:flex-1">{label(copy, 'toolkit')}
        <select aria-label={label(copy, 'toolkit')} required value={form.data.toolkit_slug} className={fieldClass} onChange={(e) => form.setData('toolkit_slug', e.target.value)}>
          <option value="">{label(copy, 'select_toolkit')}</option>
          {toolkits.map((toolkit) => <option key={toolkit.slug} value={toolkit.slug}>{toolkit.name}</option>)}
        </select>
      </label>}
      <label className="text-sm md:min-w-32 md:flex-1">{label(copy, 'validity')}
        <select aria-label={label(copy, 'validity')} value={form.data.validity_days} className={fieldClass} onChange={(e) => form.setData('validity_days', e.target.value)}>
          {validity_options.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
        </select>
      </label>
      <button className={buttonClass} disabled={form.processing}>{label(copy, 'create')}</button>
    </form>
  </section>
}
